
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexPriceGrid extends SiteEntityGrid<FactIndexPriceRow, any> {
        protected getColumnsKey() { return FactIndexPriceColumns.columnsKey; }
        protected getDialogType() { return FactIndexPriceDialog; }
        protected getIdProperty() { return FactIndexPriceRow.idProperty; }
        protected getInsertPermission() { return FactIndexPriceRow.insertPermission; }
        protected getLocalTextPrefix() { return FactIndexPriceRow.localTextPrefix; }
        protected getService() { return FactIndexPriceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}